import ProgressBarTickIcon from 'assets/images/progressBarTick.svg?react';
import cn from 'classnames';
import { motion } from 'framer-motion';
import { FC, ReactElement } from 'react';
import './styles.scss';

interface ProgressBarProps {
	numberOfSteps?: number;
	currentStep?: number;
	ProgressIcon?: ReactElement;
	progressBarType?: 'primary' | 'secondary' | 'tertiary' | 'fourthiary' | 'quinary' | 'senary';
	isProgressBarWithIcon?: boolean;
	isAnimationRequired?: boolean;
}

const ProgressBar: FC<ProgressBarProps> = ({
	numberOfSteps,
	currentStep,
	ProgressIcon,
	progressBarType = 'primary',
	isProgressBarWithIcon,
	isAnimationRequired,
}) => {
	const percentage = numberOfSteps && currentStep !== undefined ? (currentStep / numberOfSteps) * 100 : 0;

	return (
		<div
			className={cn('progressBar', {
				[`progressBar--${progressBarType}`]: progressBarType,
			})}
		>
			<motion.div
				className={cn('progressBar__fill', {
					[`progressBar__fill--${progressBarType}`]: progressBarType,
				})}
				initial={{ width: isAnimationRequired ? 0 : `${percentage}%` }}
				animate={{ width: `${percentage}%` }}
				transition={isAnimationRequired ? { duration: 0.4, ease: 'easeIn' } : { duration: 0 }}
			>
				{isProgressBarWithIcon && (ProgressIcon ? ProgressIcon : <ProgressBarTickIcon className="progressBar__indicatorDot" />)}
			</motion.div>
		</div>
	);
};

export default ProgressBar;
